




















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class StandartDraggableAlert extends Vue {
  @Prop({ type: String, default: "info" }) variant!: string;
  @Prop({ type: String, default: "" }) name!: string;

  alert_show = false;

  mounted(): void {
    this.alert_show = this.$cookies.get(this.name);
  }
}
export default StandartDraggableAlert;
